module.exports = __webpack_public_path__ + "static/img/bottomcode1.6339e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/img/bottomcode1.jpg
// module id = 8DW8
// module chunks = 1